import { BrowserRouter, Routes, Route } from "react-router-dom";
import AbstractList from "./pages/AbstractList";
import SessionDetail from "./pages/SessionDetail";
import CaseInformation from "./pages/CaseInformation";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AbstractList />} />
        <Route path="/session/:id" element={<SessionDetail />} /> 
        <Route path="/case/:caseid" element={<CaseInformation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;



